import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';

import { MercadoNomePipe } from './mercado-nome.pipe';


@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        MercadoNomePipe
    ],
    exports: [
        MercadoNomePipe
    ],
    providers: [
        MercadoNomePipe
    ]
})
export class MercadoPipeModule { }
